import { PrimeNGTranslationConstant } from "@core/constants/primeng-translation.constant";

import { PrimeNG } from "primeng/config";

import { APP_INITIALIZER, NgModule, Provider } from "@angular/core";

function initializeTranslation(config: PrimeNG): () => void {
  return (): void => config.setTranslation(PrimeNGTranslationConstant);
}

const translationProvider: Provider = {
  provide: APP_INITIALIZER,
  useFactory: initializeTranslation,
  deps: [PrimeNG],
  multi: true,
};

@NgModule({
  providers: [translationProvider],
})
export class TranslationModule {}
